import React from 'react';
import { useTranslation } from 'react-i18next';

import SectionTitle from '../../elements/section-title/SectionTitle';
import BrandItem from './BrandItem';
import { getAssetPath } from '../../utils/publicPath';

const BrandOne = ({ variant = 'default' }) => {
  const { t } = useTranslation();

  if (variant === 'mutawir') {
    const badges = t('clients.items', { returnObjects: true }) || [];
    const logos = t('clients.logos', { returnObjects: true }) || [];

    return (
      <section id="clients" className="section section-padding mutawir-clients">
        <div className="container">
          <div className="row align-items-start g-5 mutawir-section-intro">
            <div className="col-lg-6">
              <div className="mutawir-section-heading">
                <span className="mutawir-tagline">{t('clients.tagline')}</span>
                <h2 className="title">{t('clients.title')}</h2>
                <p className="mutawir-section-description">{t('clients.description')}</p>
              </div>
            </div>
            {badges.length > 0 && (
              <div className="col-lg-6">
                <div className="mutawir-badge-grid">
                  {badges.map((item, index) => (
                    <span className="mutawir-badge" key={index}>{item}</span>
                  ))}
                </div>
              </div>
            )}
          </div>
          {logos.length > 0 && (
            <div className="row g-4 mt--10">
              <BrandItem variant="mutawir" items={logos} />
            </div>
          )}
        </div>
      </section>
    );
  }

  return (
    <div className="section section-padding-2 bg-color-dark">
      <div className="container">
        <SectionTitle
          subtitle="Top Clients"
          title="We’ve built solutions for..."
          description="Design anything from simple icons to fully featured websites and applications."
          textAlignment="heading-light-left"
          textColor=""
        />
        <div className="row">
          <BrandItem />
        </div>
      </div>
      <ul className="list-unstyled shape-group-10">
        <li className="shape shape-1"><img src={getAssetPath('/images/others/line-9.png')} alt="Circle" /></li>
      </ul>
    </div>
  );
};

export default BrandOne;
